import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { contratosActions } from '../../../../application/actions/contratos';

// import { loadersActions } from '../../../../application/actions/ui_loaders';
// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';

const apiContratos = api(process.env.REACT_APP_URL);

export function* fetchContratosFuncion() {
    try {
        const token = "123456789";

        const optionalsHeaders = {
            'Authorization': `Bearer ${token}`
        }

        const { data } = yield call(apiContratos.get, 'parametro/tipocontrato', '' , optionalsHeaders);

        if (data) {
            yield put(contratosActions.contratosCorrecto({ responseContratos: data.data }));
        } else {
            yield put(contratosActions.cotnratosError());

        }

    } catch {

        yield all([
            put(contratosActions.cotnratosError())
        ]);
    }
}

export function* watchFetchContratos() {
    yield takeLatest(contratosActions.contratos.type, fetchContratosFuncion);
}

export default function* rootSaga() {
    yield spawn(watchFetchContratos);
}
